<div [formGroup]="form">
  <select class="form-control" [id]="field.name" [formControlName]="field.name">
    <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
  </select>
</div> 
